import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const PromotionGroupImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
`;
